import { actions as stationActions } from "@containers/Station/store";
import { useLoader } from "@shared/hooks";
import { useMemo } from "react";

function useStationCreateEditLoading() {
  const { isLoading: activateDeactivateStationLoading } = useLoader({
    name: "activateDeactivateStation",
    actionTypes: useMemo(() => [stationActions.activateDeactivateStation], []),
  });

  const { isLoading: getStationsConnectionsLoading } = useLoader({
    name: "getStationsConnections",
    actionTypes: useMemo(() => [stationActions.getStationsConnections], []),
  });

  const { isLoading: createStationLoading } = useLoader({
    name: "createStation",
    actionTypes: useMemo(() => [stationActions.createStation], []),
  });

  const { isLoading: updateStationLoading } = useLoader({
    name: "updateStation",
    actionTypes: useMemo(() => [stationActions.updateStation], []),
  });

  return {
    activateDeactivateStationLoading,
    getStationsConnectionsLoading,
    createStationLoading,
    updateStationLoading,
  };
}

export default useStationCreateEditLoading;
